<template>
  <div>
    <b-button @click="newEvent()">Nouvel événement</b-button>
    <b-table striped hover :items="events" 
      @row-clicked="updateEvent">
      <template slot="date" slot-scope="data">
        {{ data.value | moment("L") }}
        {{ data.value | moment("LT") }}
      </template>
    </b-table>
    
    <b-modal v-model="show" id="eventModal" title="Créer/modifier un événement">
      <b-form @submit="onSubmit" >
        <b-form-group
          label="Date et heure de debut :"
          label-for="date">
          <b-form-input class="inline-50"
            id="date"
            type="date"
            v-model="event.date"
            required />
          <b-form-input class="inline-50"
            id="date"
            type="time"
            v-model="event.start_time"
            required />
        </b-form-group>
        
        <b-form-group
          label="Heure de fin :"
          label-for="end">
          <b-form-input
            id="end"
            type="time"
            v-model="event.end_time"
            required />
        </b-form-group>

        <b-form-group
          label="Localisation :"
          label-for="location">
          <b-form-select id="location" v-model="event.location_id" :options="locations" required />
        </b-form-group>

        <b-form-group
          label="Theme :"
          label-for="theme">
          <b-form-input
            id="theme"
            type="text"
            v-model="event.theme"/>
        </b-form-group>

        <b-form-group
          label="Description :"
          label-for="description">
          <b-form-input
            id="description"
            type="text"
            v-model="event.description"/>
        </b-form-group>
        <b-button class="login-submit" type="submit" variant="primary">Créer/modifier</b-button>
        <b-button class="login-submit" type="button" v-if="event.id" variant="error" @click="deleteEvent">Supprimer</b-button>
      </b-form>
      <div slot="modal-footer">
      </div>
    </b-modal>
    
    <b-modal v-model="okModal" title="Sauvegardé" ok-only>
      <div>
        Evénement sauvegardé
      </div>
    </b-modal>
    <b-modal v-model="okDeleteModal" title="Supprimé" ok-only>
      <div>
        Evénement supprimé
      </div>
    </b-modal>
    <b-modal v-model="errorModal" title="Oups !!!" ok-only>
      <div>
        Une erreur est survenue
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
export default {
  name: 'AdminEvent',
  data: function(){
    return {
      events: [],
      event: {},
      locations: [],
      show: false,
      okModal: false,
      errorModal: false,
      okDeleteModal: false,
    }
  },
  created: function(){
    this.reloadList();
    Vue.$backend.getLocations().then(res => {
      this.locations = res
      for(const loc of this.locations){
        loc.text = loc.name;
        loc.value = loc.id;
      }
    })
  },
  methods: {
    newEvent() {
      this.event = {
        start_time: '19:30',
        end_time: '23:30',
        location_id: this.locations[0].id,
        description: null,
        theme: null,
      }
      this.show = true
    },
    updateEvent(event){
      const localDate = moment(event.date);
      
      this.event = {
        id: event.id,
        date: event.date.substr(0,10),
        start_time: localDate.format("HH:mm"),
        end_time: event.end_time,
        location_id: event.location_id,
        description: event.description,
        theme: event.theme,
      }
      this.show = true
    },
    deleteEvent(){
      Vue.$backend.deleteEvent(this.event.id).then(() => {
        this.show = false
        this.okDeleteModal = true
        this.reloadList()
      }, () => {
        this.errorModal = true
      })    
    },
    reloadList() {
      Vue.$backend.listFutureEvents().then(res => this.events = res)
    },
    onSubmit(evt) {
      evt.preventDefault()
      
      const event = {
        "date": new Date(this.event.date+'T'+this.event.start_time).toISOString(),
        "end_time": this.event.end_time,
        "description": this.event.description,
        "theme": this.event.theme,
        "location_id": this.event.location_id,
      };
      
      if(this.event.id){
        event.id = this.event.id
        
        Vue.$backend.updateEvent(event).then(() => {
          this.show = false
          this.okModal = true
          this.reloadList()
        }, () => {
          this.errorModal = true
        })    
      } else {
        Vue.$backend.createEvent(event).then(() => {
          this.show = false
          this.okModal = true
          this.reloadList()
        }, () => {
          this.errorModal = true
        })    
      }
       
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.inline-50 {
  width:50%;
  display: inline-block;
}

</style>
